// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".payment-amount[data-v-4acdf9d5] {\n  max-width: 200px;\n}\n@media only screen and (max-width: 768px) {\n.payment-amount[data-v-4acdf9d5] {\n    max-width: 70%;\n}\n}", ""]);
// Exports
module.exports = exports;
